<template>
    <div>
        <basic-container>
            <div class="news-ele" v-loading="loading">
                <div class="banner_w3lspvt-2">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item" aria-current="page">{{ $t('reCheck.newsTitle') }}</li>
                    </ol>
                </div>
                <div class="container">
                    <el-card v-for="(item, index) in newsList" :key="index" class="newsList-ele-item">
                        <h5 @click="tapNewsUrl(item.newsWebsite)">{{ lang == 'en' ? item.titleEnglish : item.title }}</h5>
                        <p>{{ item.author }}</p>
                        <p>{{ item.publishedTime }}</p>
                    </el-card>
                    <!-- 分页 -->
                    <div class="pagination">
                        <el-pagination v-if="total > 10" small layout="prev, pager, next" :current-page.sync="page"
                            :page-size="pageSize" :total="total" @current-change="updateCurrentPageData"
                            :prev-text="$t('paginationText.prevText')"
                            :next-text="$t('paginationText.nextText')"></el-pagination>
                    </div>

                </div>
            </div>
        </basic-container>
    </div>
</template>

<script>
import { getRecheckNewsData } from '@/api/recheck/news'
export default {
    data() {
        return {
            newsList: [],
            pageSize: 10,
            total: 100,
            page: 1,
            loading: false,
            lang:localStorage.getItem("lang")
        };
    },
    created() { },
    mounted() {
        this.getRecheckNewsList()
    },
    methods: {
        getRecheckNewsList() {
            this.loading = true;
            let params = { page: this.page, pageSize: this.pageSize }
            getRecheckNewsData(params).then(res => {
                let data = res.data
                this.newsList = data.records
                this.total = data.total
                this.loading = false
            })
        },
        tapNewsUrl(url) {
            window.open(url, '_blank')
        },
        updateCurrentPageData(val) {
            this.page = val
            this.getRecheckNewsList()
        }
    },
};
</script>

<style lang="scss" scoped>
.container {
    margin-top: 60px;
}

.el-card {
    border-radius: 8px;
    margin: 20px 0;

    h5 {
        color: #4e6ef2;
    }

    h5:hover {
        cursor: pointer;
    }

    p {
        margin-bottom: 0;
    }
}

.el-pagination {
    display: flex;
    align-items: center;
}

.pagination {
    margin: 30px auto;
}
</style>
